module.exports = __webpack_public_path__ + "static/media/wulianwang.62360bac.png";